// extracted by mini-css-extract-plugin
module.exports = {"ProjectsCard":"ProjectsCard_ProjectsCard__F_wC1","Content":"ProjectsCard_Content__WVKc1","Title":"ProjectsCard_Title__TeH5k","UserInfo":"ProjectsCard_UserInfo__lDaHg"};